var _rect, _circle, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachersHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 420,
    viewBox: "0 0 480 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 476,
    height: 416,
    rx: 16,
    fill: "#FEF8D8",
    stroke: "#00296B",
    strokeWidth: 2,
    strokeDasharray: "8 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 190,
    r: 36,
    fill: "#00296B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 224 180 l 32 18 l -32 18 z",
    fill: "#FFD600",
    transform: "translate(0,0)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 260,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: 600,
    fill: "#00296B",
    textAnchor: "middle"
  }, "Teachers Hero")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 282,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#6E7485",
    textAnchor: "middle"
  }, "Placeholder image")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachersHeader);
export default __webpack_public_path__ + "static/media/teachers-header.a72d3dc8841ee364109672169a8bb7e7.svg";
export { ForwardRef as ReactComponent };